module.exports = __webpack_public_path__ + "static/media/signal-slash.f98a36bd.svg";